export default __webpack_public_path__ + "static/media/2.2057257b.webp";